import Phaser from 'phaser';

import gameConfig from '../../../config/game';
import EggItem from './_item';
import EggWord from './_word';



export default class Eggs{

    constructor(){
        GAME_REF.obj.eggs = this;
        this.scene = GAME_REF.scene;
        this.manager = GAME_REF.obj.manager;

        this.items = [];
        this.nextItems = [];
        this.word = null;
        this.isDraggable = false;

        this._pause = this._pause.bind(this);
        this._resume = this._resume.bind(this);

        this._init();
    }


    render(list){
        this._create(list);
        window.addEventListener(PLAYBACK.EVENT.PAGE_PAUSE, this._pause);
        window.addEventListener(PLAYBACK.EVENT.PAGE_RESUME, this._resume);
    }


    start(){
        this.isDraggable = true;
    }


    next(){
        this.word.destroy();
        
        for(let i=0; i<this.nextItems.length; i++){
            this.nextItems[i].render();
        }

        this.nextItems = [];
    }


    gameEnd(){
        this.isDraggable = false;
    }


    removeItem(item){

        // アイテムのインデックスを取得
        const index = this.items.indexOf(item);

        // 指定したEggItemをシーンから削除
        item.destroy();

        // 指定したEggItemをitems配列から削除
        if(index !== -1){
            this.items.splice(index, 1);
        }

        let newData;

        // 同じkeyが存在するか調べる        
        const keys = this.items.map(item => item.data.key);
        const uniqueKeys = new Set(keys);

         // 重複するkeyが存在(揃う果物がすでにある)
        if(keys.length !== uniqueKeys.size){
            newData = gameConfig.items[ Math.floor(Math.random() * gameConfig.items.length) ];
        }
        // 重複しない(揃わない)
        else{
            const randomItem = this.items[Math.floor(Math.random() * this.items.length)];
            newData = randomItem.data;
        }

        this._createNewItem(index, newData);
    }


    showAnswer(key, x, y){
        this.word.render(key, x, y);
    }


    _init(){
        this.word = new EggWord();
    }


    _create(list){
        
        for(let i=0; i<list.length; i++){
            const item = new EggItem(list[i], i, gameConfig.pos[i].x, gameConfig.pos[i].y);
            item.render();
            this.items.push(item);
        }

        //this._eggSwing();
    }

    
    _createNewItem(index, data){
        const newItem = new EggItem(data, index, gameConfig.pos[index].x, gameConfig.pos[index].y);
        this.items.splice(index, 0, newItem);
        this.nextItems.push(newItem);
    }


    _eggSwing(){
        let randomIndex = Phaser.Math.Between(0, this.items.length - 1);
        this.items[randomIndex].startSwing(this._eggSwing.bind(this));
    }


    _pause(){
        this.isDraggable = false;
    }

    _resume(){
        this.isDraggable = true;
    }
}